<template>
  <app-layout>
    <router-view />
  </app-layout>
  <update-notification />
  <install-notification />
</template>

<script>
import UpdateNotification from '@/components/UpdateNotification.vue';
import InstallNotification from '@/components/InstallNotification.vue';
import {mapActions} from "vuex";

import AppLayout from "@/layouts/AppLayout.vue";

export default {
  name: 'App',
  components: {
    AppLayout,
    InstallNotification,
    UpdateNotification,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      setOrientationPortrait: 'device/setOrientationPortrait',
      setOrientationLandscape: 'device/setOrientationLandscape',
    }),
    setOrientation() {
      if (document.documentElement.clientWidth >= document.documentElement.clientHeight) {
        this.setOrientationLandscape();
      } else {
        this.setOrientationPortrait();
      }
    },
  },
  beforeCreate() {
    this.$store.commit('initStore');
  },
  mounted() {
    this.setOrientation();
    window.addEventListener('resize', this.setOrientation);
  },
  unmounted() {
    window.removeEventListener('resize', this.setOrientation);
  },
}
</script>
